import React from 'react';
import List from 'shared/layout/list';
import useProjection from 'shared/migration-hooks/use-projection';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import {CouponRedemptionProps} from 'modules/coupon-redemptions/types';
import couponRedemptionsKeys from 'modules/coupon-redemptions/util/coupon-redemptions';
import dateFnsService from 'shared/services/date-fns-service';
import todayFilter from 'shared/util/today-filter';
import {useNavigate} from 'react-router-dom';

const CouponRedemptions: React.FC = () => {
  const projection = useProjection<CouponRedemptionProps>(
    'couponRedemptions',
    [
      'id',
      'company.name',
      'coupon.name',
      'user.name',
      'phone',
      'city.name',
      'order.number',
      'redeemedAt',
    ],
    {
      defaultFilters: {
        redeemedAt: JSON.stringify(todayFilter) as any,
      },
      overrideDefaultValues: true,
    },
  );

  const {companyId, cityId} = useAccessControls();
  const navigate = useNavigate();

  return (
    <List<CouponRedemptionProps>
      {...{
        titleBar: {
          title: 'Cupons',
        },
        dateFilter: {startDateField: 'redeemedAt'},
        table: {
          url: '/coupon-redemptions',
          projection: {
            ...projection,
            options: [
              'user.name',
              'phone',
              'coupon.name',
              {value: 'company.name', hidden: !!companyId},
              {value: 'city.name', hidden: !!cityId},
              {value: 'order.number', column: (row) => `#${row.order.number}`},
              {
                value: 'redeemedAt',
                column: (row) => dateFnsService.dateTimeFormat(row.redeemedAt),
                hideFilter: true,
              },
            ],
          },
          translatedPropsKey: 'CouponRedemptionProps',
          onRowClick: (row) => navigate(`/orders/${row.orderId}`),
        },
        queryKey: couponRedemptionsKeys.list(),
        fixedColumns: ['orderId'],
      }}
    />
  );
};

export default CouponRedemptions;
